import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { isIOS } from "../util/functions";

let beamsClient = {
    start: () => Promise.resolve(),
    stop: () => Promise.resolve(),
    setUserId: () => Promise.resolve(),
    getUserId: () => Promise.resolve(),
    addDeviceInterest: () => Promise.resolve(),
};

if (!isIOS()) {
    beamsClient = new PusherPushNotifications.Client({
        instanceId: 'b8889963-3f5e-48c2-b538-6297d3384631',
    });
}

export { beamsClient };